import { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { AppShell, PlaceholderPage } from "./components/AppShell";
import { ADMIN_PATH, AdminPage } from "./features/admin/AdminPage";
import { ExplorePage } from "./features/explore/ExplorePage";
import { FamilyPage } from "./features/family/FamilyPage";
import { useAuth } from "./features/auth/auth-context";
import { LoginPage } from "./features/auth/LoginPage";
import { DashboardPage } from "./features/home/DashboardPage";
import { TripsPage } from "./features/trips/TripsPage";
import { TravelMode, TripWorkspace } from "./features/trips/TripWorkspace";

function Protected({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="app-loader"><span /><p>Gathering your journeys…</p></div>;
  return user ? children : <Navigate to="/login" replace />;
}

function AdminOnly({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="app-loader"><span /><p>Verifying access…</p></div>;
  return user?.is_admin
    ? children
    : <Navigate to="/" replace />;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  return <><ScrollToTop /><Routes>
    <Route path="/login" element={<LoginPage />} />
    <Route path={ADMIN_PATH} element={<Protected><AdminOnly><AdminPage /></AdminOnly></Protected>} />
    <Route element={<Protected><AppShell /></Protected>}>
      <Route index element={<DashboardPage />} />
      <Route path="trips" element={<TripsPage />} />
      <Route path="explore" element={<ExplorePage />} />
      <Route path="booking-safe" element={<PlaceholderPage kind="Booking Safe" />} />
      <Route path="family" element={<FamilyPage />} />
      <Route path="profile" element={<PlaceholderPage kind="Profile" />} />
      <Route path="trips/:tripId/:section" element={<TripWorkspace />} />
    </Route>
    <Route path="/trips/:tripId/travel" element={<Protected><TravelMode /></Protected>} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes></>;
}
